// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Heidi-style guided tutorial checklist */
.routine-setup-checklist-floating {
  position: fixed;
  bottom: var(--space-6);
  right: var(--space-6);
  z-index: 900;
  width: min(380px, calc(100vw - 32px));
  box-shadow: var(--shadow-lg);
  border-radius: var(--radius-lg);
}

.routine-setup-checklist {
  padding: 0;
  overflow: hidden;
}

.routine-setup-checklist-card {
  background: var(--color-surface);
  border: 1px solid var(--color-border-subtle);
  border-radius: var(--radius-lg);
}

/* Header — teal banner with progress ring */
.routine-setup-checklist-header {
  display: flex;
  align-items: center;
  gap: var(--space-3);
  padding: var(--space-4) var(--space-5);
  background: var(--accent);
  color: var(--text-on-accent);
  position: relative;
}

.routine-setup-checklist-header-copy {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
  flex: 1;
  padding-right: var(--space-5);
}

.routine-setup-checklist-close {
  position: absolute;
  top: var(--space-3);
  right: var(--space-3);
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  padding: 0;
  border: none;
  border-radius: var(--radius-sm);
  background: transparent;
  color: var(--text-on-accent);
  cursor: pointer;
  opacity: 0.85;
  transition: opacity 0.15s ease, background-color 0.15s ease;
}

.routine-setup-checklist-close:hover {
  opacity: 1;
  background: rgba(0, 0, 0, 0.14);
}

.routine-setup-checklist-header-title {
  color: var(--text-on-accent) !important;
  margin: 0;
}

.routine-setup-checklist-header-subtitle {
  color: color-mix(in srgb, var(--text-on-accent) 78%, transparent) !important;
  margin: 0;
  line-height: 1.35;
}

.routine-setup-checklist-progress-ring {
  flex-shrink: 0;
}

.routine-setup-checklist-progress-text {
  fill: var(--text-on-accent);
  font-size: 11px;
  font-weight: 700;
  font-family: 'Urbanist', sans-serif;
}

/* Vertical stepper list */
.routine-setup-checklist-steps {
  list-style: none;
  padding: var(--space-3) var(--space-4) var(--space-4);
  margin: 0;
}

.routine-setup-checklist-step {
  margin: 0;
  padding: 0;
}

.routine-setup-checklist-step-button {
  display: flex;
  align-items: flex-start;
  gap: var(--space-3);
  width: 100%;
  background: none;
  border: 1px solid transparent;
  cursor: default;
  padding: var(--space-2) var(--space-3);
  text-align: left;
  font: inherit;
  border-radius: var(--radius-sm);
  transition: background-color 0.2s ease, border-color 0.2s ease;
}

.routine-setup-checklist-step.active .routine-setup-checklist-step-button {
  cursor: pointer;
  background: var(--color-pastelle-blue);
  border-color: var(--accent-ring);
}

.routine-setup-checklist-step.active .routine-setup-checklist-step-button:hover {
  background: var(--color-light-green);
  border-color: var(--color-primary-green);
}

.routine-setup-checklist-step-button:disabled {
  cursor: default;
}

.routine-setup-checklist-step-track {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-shrink: 0;
  width: 22px;
  padding-top: 2px;
}

.routine-setup-checklist-step-indicator {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  z-index: 1;
}

.routine-setup-checklist-step.completed .routine-setup-checklist-step-indicator {
  background: var(--color-primary-green);
  border: 2px solid var(--color-primary-green);
}

.routine-setup-checklist-step.active .routine-setup-checklist-step-indicator {
  background: var(--color-white);
  border: 2px solid var(--color-primary-green);
  box-shadow: 0 0 0 2px var(--accent-ring);
}

.routine-setup-checklist-step.pending .routine-setup-checklist-step-indicator {
  background: var(--color-white);
  border: 2px solid var(--color-gray);
}

.routine-setup-checklist-step-connector {
  width: 2px;
  flex: 1;
  min-height: 14px;
  margin: 4px 0;
  background: var(--color-gray);
}

.routine-setup-checklist-step.completed .routine-setup-checklist-step-connector {
  background: var(--color-primary-green);
}

.routine-setup-checklist-step-content {
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1;
  min-width: 0;
  padding-top: 1px;
}

.routine-setup-checklist-step-label {
  margin: 0;
  font-weight: 500;
  color: var(--color-black);
}

.routine-setup-checklist-step.completed .routine-setup-checklist-step-label {
  color: var(--color-dark-gray);
}

.routine-setup-checklist-step.pending .routine-setup-checklist-step-label {
  color: var(--color-dark-gray);
}

.routine-setup-checklist-step-helper {
  margin: 0;
  color: var(--color-dark-gray);
  line-height: 1.35;
}

.routine-setup-checklist-step-chevron {
  flex-shrink: 0;
  margin-top: 2px;
}

/* Flash / pulse for Update Routines button when checklist step 2 is active */
.routine-setup-checklist-highlight-update-button {
  animation: routine-setup-pulse 0.75s ease-in-out 2;
}

@keyframes routine-setup-pulse {
  0%, 100% { box-shadow: 0 0 0 0 var(--accent-ring); }
  50%  { box-shadow: 0 0 0 12px transparent; }
}

@media (max-width: 768px) {
  .routine-setup-checklist-floating {
    /* Clear the sticky homepage dial (+ home indicator) so both stay usable. */
    bottom: calc(var(--orbit-dial-reserve, 148px) + var(--space-3));
    right: var(--space-4);
    left: var(--space-4);
    width: auto;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/RoutineSetupChecklist/RoutineSetupChecklist.css"],"names":[],"mappings":"AAAA,0CAA0C;AAC1C;EACE,eAAe;EACf,sBAAsB;EACtB,qBAAqB;EACrB,YAAY;EACZ,qCAAqC;EACrC,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,4CAA4C;EAC5C,+BAA+B;AACjC;;AAEA,4CAA4C;AAC5C;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,sCAAsC;EACtC,yBAAyB;EACzB,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,OAAO;EACP,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,+BAA+B;EAC/B,uBAAuB;EACvB,4BAA4B;EAC5B,eAAe;EACf,aAAa;EACb,2DAA2D;AAC7D;;AAEA;EACE,UAAU;EACV,+BAA+B;AACjC;;AAEA;EACE,uCAAuC;EACvC,SAAS;AACX;;AAEA;EACE,4EAA4E;EAC5E,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA,0BAA0B;AAC1B;EACE,gBAAgB;EAChB,qDAAqD;EACrD,SAAS;AACX;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,6BAA6B;EAC7B,eAAe;EACf,sCAAsC;EACtC,gBAAgB;EAChB,aAAa;EACb,+BAA+B;EAC/B,8DAA8D;AAChE;;AAEA;EACE,eAAe;EACf,sCAAsC;EACtC,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,wCAAwC;AAC1C;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;EACd,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,sCAAsC;EACtC,4CAA4C;AAC9C;;AAEA;EACE,8BAA8B;EAC9B,4CAA4C;EAC5C,wCAAwC;AAC1C;;AAEA;EACE,8BAA8B;EAC9B,mCAAmC;AACrC;;AAEA;EACE,UAAU;EACV,OAAO;EACP,gBAAgB;EAChB,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,OAAO;EACP,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,SAAS;EACT,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,6EAA6E;AAC7E;EACE,kDAAkD;AACpD;;AAEA;EACE,WAAW,sCAAsC,EAAE;EACnD,OAAO,kCAAkC,EAAE;AAC7C;;AAEA;EACE;IACE,2EAA2E;IAC3E,+DAA+D;IAC/D,qBAAqB;IACrB,oBAAoB;IACpB,WAAW;EACb;AACF","sourcesContent":["/* Heidi-style guided tutorial checklist */\n.routine-setup-checklist-floating {\n  position: fixed;\n  bottom: var(--space-6);\n  right: var(--space-6);\n  z-index: 900;\n  width: min(380px, calc(100vw - 32px));\n  box-shadow: var(--shadow-lg);\n  border-radius: var(--radius-lg);\n}\n\n.routine-setup-checklist {\n  padding: 0;\n  overflow: hidden;\n}\n\n.routine-setup-checklist-card {\n  background: var(--color-surface);\n  border: 1px solid var(--color-border-subtle);\n  border-radius: var(--radius-lg);\n}\n\n/* Header — teal banner with progress ring */\n.routine-setup-checklist-header {\n  display: flex;\n  align-items: center;\n  gap: var(--space-3);\n  padding: var(--space-4) var(--space-5);\n  background: var(--accent);\n  color: var(--text-on-accent);\n  position: relative;\n}\n\n.routine-setup-checklist-header-copy {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n  flex: 1;\n  padding-right: var(--space-5);\n}\n\n.routine-setup-checklist-close {\n  position: absolute;\n  top: var(--space-3);\n  right: var(--space-3);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  padding: 0;\n  border: none;\n  border-radius: var(--radius-sm);\n  background: transparent;\n  color: var(--text-on-accent);\n  cursor: pointer;\n  opacity: 0.85;\n  transition: opacity 0.15s ease, background-color 0.15s ease;\n}\n\n.routine-setup-checklist-close:hover {\n  opacity: 1;\n  background: rgba(0, 0, 0, 0.14);\n}\n\n.routine-setup-checklist-header-title {\n  color: var(--text-on-accent) !important;\n  margin: 0;\n}\n\n.routine-setup-checklist-header-subtitle {\n  color: color-mix(in srgb, var(--text-on-accent) 78%, transparent) !important;\n  margin: 0;\n  line-height: 1.35;\n}\n\n.routine-setup-checklist-progress-ring {\n  flex-shrink: 0;\n}\n\n.routine-setup-checklist-progress-text {\n  fill: var(--text-on-accent);\n  font-size: 11px;\n  font-weight: 700;\n  font-family: 'Urbanist', sans-serif;\n}\n\n/* Vertical stepper list */\n.routine-setup-checklist-steps {\n  list-style: none;\n  padding: var(--space-3) var(--space-4) var(--space-4);\n  margin: 0;\n}\n\n.routine-setup-checklist-step {\n  margin: 0;\n  padding: 0;\n}\n\n.routine-setup-checklist-step-button {\n  display: flex;\n  align-items: flex-start;\n  gap: var(--space-3);\n  width: 100%;\n  background: none;\n  border: 1px solid transparent;\n  cursor: default;\n  padding: var(--space-2) var(--space-3);\n  text-align: left;\n  font: inherit;\n  border-radius: var(--radius-sm);\n  transition: background-color 0.2s ease, border-color 0.2s ease;\n}\n\n.routine-setup-checklist-step.active .routine-setup-checklist-step-button {\n  cursor: pointer;\n  background: var(--color-pastelle-blue);\n  border-color: var(--accent-ring);\n}\n\n.routine-setup-checklist-step.active .routine-setup-checklist-step-button:hover {\n  background: var(--color-light-green);\n  border-color: var(--color-primary-green);\n}\n\n.routine-setup-checklist-step-button:disabled {\n  cursor: default;\n}\n\n.routine-setup-checklist-step-track {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  flex-shrink: 0;\n  width: 22px;\n  padding-top: 2px;\n}\n\n.routine-setup-checklist-step-indicator {\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-sizing: border-box;\n  z-index: 1;\n}\n\n.routine-setup-checklist-step.completed .routine-setup-checklist-step-indicator {\n  background: var(--color-primary-green);\n  border: 2px solid var(--color-primary-green);\n}\n\n.routine-setup-checklist-step.active .routine-setup-checklist-step-indicator {\n  background: var(--color-white);\n  border: 2px solid var(--color-primary-green);\n  box-shadow: 0 0 0 2px var(--accent-ring);\n}\n\n.routine-setup-checklist-step.pending .routine-setup-checklist-step-indicator {\n  background: var(--color-white);\n  border: 2px solid var(--color-gray);\n}\n\n.routine-setup-checklist-step-connector {\n  width: 2px;\n  flex: 1;\n  min-height: 14px;\n  margin: 4px 0;\n  background: var(--color-gray);\n}\n\n.routine-setup-checklist-step.completed .routine-setup-checklist-step-connector {\n  background: var(--color-primary-green);\n}\n\n.routine-setup-checklist-step-content {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  flex: 1;\n  min-width: 0;\n  padding-top: 1px;\n}\n\n.routine-setup-checklist-step-label {\n  margin: 0;\n  font-weight: 500;\n  color: var(--color-black);\n}\n\n.routine-setup-checklist-step.completed .routine-setup-checklist-step-label {\n  color: var(--color-dark-gray);\n}\n\n.routine-setup-checklist-step.pending .routine-setup-checklist-step-label {\n  color: var(--color-dark-gray);\n}\n\n.routine-setup-checklist-step-helper {\n  margin: 0;\n  color: var(--color-dark-gray);\n  line-height: 1.35;\n}\n\n.routine-setup-checklist-step-chevron {\n  flex-shrink: 0;\n  margin-top: 2px;\n}\n\n/* Flash / pulse for Update Routines button when checklist step 2 is active */\n.routine-setup-checklist-highlight-update-button {\n  animation: routine-setup-pulse 0.75s ease-in-out 2;\n}\n\n@keyframes routine-setup-pulse {\n  0%, 100% { box-shadow: 0 0 0 0 var(--accent-ring); }\n  50%  { box-shadow: 0 0 0 12px transparent; }\n}\n\n@media (max-width: 768px) {\n  .routine-setup-checklist-floating {\n    /* Clear the sticky homepage dial (+ home indicator) so both stay usable. */\n    bottom: calc(var(--orbit-dial-reserve, 148px) + var(--space-3));\n    right: var(--space-4);\n    left: var(--space-4);\n    width: auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
